import { render, staticRenderFns } from "./KEmptyPlaceholder.vue?vue&type=template&id=3f769807&scoped=true&"
import script from "./KEmptyPlaceholder.vue?vue&type=script&lang=js&"
export * from "./KEmptyPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f769807",
  null
  
)

export default component.exports